module.exports = __webpack_public_path__ + "img/modal-template.dfe1e543.svg";